// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__zjfze","rightBox":"App_rightBox__U1izG","container":"App_container__3XBpB","linkBack":"App_linkBack__dgr8v","particles":"App_particles__-a+LT"};